(function(){
'use strict';
/* ---------- packed-box data (Weight & Dimensions sheet, Aug 2026) ---------- */
var BOX = {
  walls: {rows:[["1500mm W wall","107 × 27 × 17","8.1"],["1980mm W wall","107 × 27 × 23","9.4"],["2980mm W wall","107 × 27 × 21","11.4"],["3980mm W wall","109 × 27 × 32","15.6"],["5980mm W wall","107 × 32 × 33","24.1"]],
          chips:["One box — frame, fabric & carry bag inside","Fits a car back seat"]},
  curvedwall: {rows:[["Curved wall kit","99 × 23 × 27","9.8"]], chips:["One box — frame, fabric & carry bag inside"]},
  popup: {rows:[["Pop up display kit","99 × 35 × 31","16.4"]], chips:["One box — frame, fabric & carry bag inside"]},
  pullups: {rows:[["Standard pull up","88 × 12 × 12","3.3"],["Wide pull up","116 × 12 × 12","4.4"],["Premium pull up","90 × 30 × 11","6.6"],["Carton of 4 standard","88 × 24 × 23","14.1"]],
            chips:["Carry bag included in the box"]},
  flags: {rows:[["Flag + poles + case (Small)","150 × 13 × 13","~2.4"],["Flag + poles + case (Medium)","150 × 18 × 18","~2.9"],["Flag + poles + case (Large)","150 × 25 × 25","~3.4"],["+ Cross base","84 × 5 × 6","4.0"],["+ Metal plate","41.5 × 41.5 × 2.3","4.5"],["+ Concrete base","41 × 41 × 8","10"]],
          chips:["Poles & flag ship in one slim box"]},
  throws: {rows:[["4 foot throw","satchel 40 × 32","~1.0"],["6 foot throw","satchel 40 × 32","~1.6"],["8 foot throw","satchel 58 × 45","~1.9"]],
           chips:["Ships folded in a compact satchel"]},
  runners: {rows:[["Table runner","satchel 40 × 32","~1"]], chips:["Ships folded in a compact satchel"]},
  corflute: {rows:[["600 × 900mm signs","flat box 63 × 93","0.5 ea"],["600 × 450mm signs","flat box 63 × 48","0.25 ea"]],
             chips:["Flat-packed with protective wrap"]},
  aframe: {rows:[["A-frame kit","103 × 10 × 63","7.8"],["Real estate A-frame","63 × 10 × 59","5.7"]], chips:["Inserts ship inside the frame box"]},
  lightbox: {rows:[["1m light box","115 × 14 × 39","9.6"],["2m light box","135 × 41 × 25","23.4"],["3m light box","136 × 42 × 25","27.5"],["4m light box","135 × 40.5 × 32","34.8"]], chips:["Frame, fabric & LEDs in one box"]},
  bannerstand: {rows:[["Stand 610 × 2400","71 × 12 × 22","6.0"],["Stand 850 × 2000","91 × 11 × 22","7.2"]], chips:["Fabric ships inside the hardware box"]},
  cafebarrier: {rows:[["Cafe barrier kit","115 × 44 × 10","7.5"]], chips:[]},
  counter: {rows:[["Pop up counter kit","116 × 21 × 41","12.4"]], chips:[]},
  fabricbanner: {rows:[["Fabric banner","satchel 40 × 32","<1"]], chips:["Ships folded in a compact satchel"]}
};
/* ---------- care copy per family ---------- */
var IC = {
  wash:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><circle cx="12" cy="13" r="5"/><path d="M4 4h16v16H4z" stroke-linejoin="round"/><path d="M9.5 13a2.5 2.5 0 0 0 5 0"/><circle cx="7" cy="6.5" r=".4"/><circle cx="9.5" cy="6.5" r=".4"/></svg>',
  sun:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M4 20h16M6 20V9m12 11V9M6 9h12M9 9v6m6-6v6m-3-6v8"/></svg>',
  box:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M3 8l9-5 9 5v8l-9 5-9-5z"/><path d="M3 8l9 5 9-5M12 13v8"/></svg>',
  cloth:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M4 15c2-2 4-2 6 0s4 2 6 0 3-1.5 4-1"/><path d="M4 10c2-2 4-2 6 0s4 2 6 0 3-1.5 4-1"/></svg>',
  wind:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M3 8h11a3 3 0 1 0-3-3M3 13h15a3 3 0 1 1-3 3M3 18h8a2 2 0 1 1-2 2"/></svg>'
};
var CARE = {
  fabric: {t:"Keep it looking brand new", li:[
    [IC.wash,"<b>Washing</b> — machine washable, <b>cold wash only</b>, gentle cycle. No bleach or harsh detergents."],
    [IC.sun,"<b>Drying</b> — hang to dry, never tumble dry. Creases drop out once re-stretched."],
    [IC.box,"<b>Storage</b> — roll or fold loosely in the carry bag; avoid hard creases."],
    [IC.cloth,"<b>Hardware</b> — wipe frames & poles with a dry cloth; keep joints grit-free."]]},
  throws: {t:"Washing & care", li:[
    [IC.wash,"<b>100% machine washable</b> — cold wash, gentle cycle, no bleach."],
    [IC.sun,"<b>Hang to dry</b> — no tumble drying or dry cleaning. Iron low, inside-out, only if needed."],
    [IC.box,"<b>Storage</b> — fold loosely or roll; store completely dry."]]},
  flags: {t:"Get seasons of life from your flag", li:[
    [IC.wash,"<b>Washing</b> — cold hand or machine wash, no bleach; hang to dry."],
    [IC.wind,"<b>Weather</b> — flags love a breeze, not a gale. Bring them in during storms and very strong wind."],
    [IC.box,"<b>Never store wet</b> — dry fully before packing the case to stop mildew."],
    [IC.cloth,"<b>Poles</b> — wipe off sand and grit before sliding sections together."]]},
  pullups: {t:"Care for your pull up banner", li:[
    [IC.cloth,"<b>Cleaning</b> — soft damp cloth on the print; no solvents or abrasives."],
    [IC.wind,"<b>Retract gently</b> — guide it down with two hands; snapping back wears the spring."],
    [IC.box,"<b>Transport & storage</b> — carry bag, base-down; store retracted, dry, out of direct sun."]]},
  rigid: {t:"Care for your signage", li:[
    [IC.cloth,"<b>Cleaning</b> — damp cloth with mild soapy water; no solvents or scourers."],
    [IC.wind,"<b>Outdoors</b> — secure firmly; bring lightweight signs in during storms."],
    [IC.box,"<b>Storage</b> — flat, out of direct sun, away from heat."]]},
  hardware: {t:"Care for your display", li:[
    [IC.wash,"<b>Fabric parts</b> — cold machine wash, no bleach; hang to dry and re-fit."],
    [IC.cloth,"<b>Frame & electricals</b> — dry cloth only; never wash powered parts."],
    [IC.box,"<b>Storage</b> — pack dry into the bag or box between events."]]}
};
/* ---------- family matching ---------- */
var HANDLES = {
  "straight-stretch-fabric-walls":["walls","fabric"], "curved-media-walls":["curvedwall","fabric"],
  "exhibition-display-stand":["popup","fabric"], "pullup-banners":["pullups","pullups"],
  "premium-pullup-banners":["pullups","pullups"], "teardrop-banners-flags":["flags","flags"],
  "feather-flags":["flags","flags"], "bow-head-flags":["flags","flags"],
  "table-throws":["throws","throws"], "table-runner":["runners","throws"],
  "fabric-banners":["fabricbanner","fabric"], "corrugated-plastic-signs":["corflute","rigid"]
};
var KEYWORDS = [
  [/slimline|stretch fabric wall|media wall/i, "walls","fabric"],
  [/stretch fabric display|pop ?up display/i, "popup","fabric"],
  [/pull ?up banner/i, "pullups","pullups"],
  [/promotional flag|teardrop|feather|bow ?head|flag/i, "flags","flags"],
  [/table throw|table cover|tablecloth/i, "throws","throws"],
  [/table runner/i, "runners","throws"],
  [/corflute|corrugated|foam board|rigid sign|a-?board|bollard/i, "corflute","rigid"],
  [/a ?frame/i, "aframe","rigid"],
  [/light ?box/i, "lightbox","hardware"],
  [/banner stand/i, "bannerstand","fabric"],
  [/cafe barrier/i, "cafebarrier","fabric"],
  [/counter/i, "counter","hardware"],
  [/fabric banner/i, "fabricbanner","fabric"]
];
function family(){
  var ctx; try { ctx = JSON.parse(document.getElementById('vvsc-ctx').textContent); } catch(e){ return null; }
  if (HANDLES[ctx.handle]) return HANDLES[ctx.handle];
  var hay = (ctx.type||'') + ' ' + (ctx.title||'');
  for (var i=0;i<KEYWORDS.length;i++) if (KEYWORDS[i][0].test(hay)) return [KEYWORDS[i][1], KEYWORDS[i][2]];
  return null;
}
/* ---------- render ---------- */
function build(){
  if (document.querySelector('.vvsc')) return;
  var fam = family(); if (!fam) return;
  var box = BOX[fam[0]], care = CARE[fam[1]];
  if (!box && !care) return;
  /* insertion point: BELOW the product tabs (tab panes), not above them */
  var tabsUl = document.querySelector('ul.nav-tabs');
  var anchor = null;
  if (tabsUl){
    var wrap = tabsUl.parentElement;
    anchor = (wrap && wrap.querySelector('.tab-content')) || wrap || tabsUl;
  }
  anchor = anchor || document.querySelector('#tab_border') || document.querySelector('.product:not(.product--quick)');
  if (!anchor) return;
  var el = document.createElement('section');
  el.className = 'vvsc';
  /* 10 Sep 2026 — anchor target for the "Specs & sizes" jump chip. That chip
     pointed at #desc, the same anchor as "Overview", so two of the four chips
     did the identical thing: Overview took 433 clicks on /products/media-wall
     and Specs & sizes took 6. This block ("What arrives at your door": packed
     box dimensions and weights) is the specs content, so it becomes the target. */
  el.id = 'vvsc-specs';
  var h = '<div class="vvsc-card">';
  h += '<div class="vvsc-head"><span class="vvsc-kick">Good to know</span>';
  h += '<h2>What arrives at your door</h2>';
  h += '<p>Exact packed box size and weight — handy for car space, freight and site planning.</p></div>';
  h += '<div class="vvsc-cols">';
  if (box){
    h += '<div class="vvsc-col">';
    h += '<table class="vvsc-box"><thead><tr><th>Item</th><th>Box L × W × H <em>(cm)</em></th><th class="r">Weight <em>(kg)</em></th></tr></thead><tbody>';
    box.rows.forEach(function(r){ h += '<tr><td>'+r[0]+'</td><td>'+r[1]+'</td><td class="r"><b>'+r[2]+'</b></td></tr>'; });
    h += '</tbody></table>';
    if ((box.chips||[]).length){
      h += '<div class="vvsc-chips">';
      box.chips.forEach(function(c){ h += '<span class="vvsc-chip"><i>✓</i>'+c+'</span>'; });
      h += '</div>';
    }
    h += '</div>';
  }
  if (care){
    h += '<div class="vvsc-col vvsc-carecol"><div class="vvsc-care">';
    h += '<h3>Care instructions</h3><p class="vvsc-caresub">'+care.t+'</p><ul>';
    care.li.forEach(function(li){ h += '<li><span class="vvsc-ic">'+li[0]+'</span><span>'+li[1]+'</span></li>'; });
    h += '</ul></div></div>';
  }
  h += '</div></div>';
  el.innerHTML = h;
  if (anchor.parentNode) anchor.parentNode.insertBefore(el, anchor.nextSibling);
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function(){ setTimeout(build, 400); });
else setTimeout(build, 400);
})();
